import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as null | DeliveryAddress;

const slice = createSlice({
  name: 'desiredDeliveryAddress',
  initialState,
  reducers: {
    setDesiredDeliveryAddress(state, action: PayloadAction<DeliveryAddress | null>) {
      const { payload } = action;
      return payload == null ? initialState : payload;
    },
  },
});

export const { setDesiredDeliveryAddress } = slice.actions;

export default slice.reducer;
